import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormatTimeModule } from '@go-modules/pipes/format-time/format-time.module';
import { FormsModule } from '@angular/forms';
import { ActivityInfoComponent } from './activity-info.component';
import { MediaCardModule } from '../media-card/media-card.module';
import { RichInstructionsModule } from '../rich-instructions/rich-instructions.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormatTimeModule,
		FormsModule,
		MediaCardModule,
		RichInstructionsModule
	],
	declarations: [
		ActivityInfoComponent
	],
	exports: [
		ActivityInfoComponent
	]
})
export class ActivityInfoModule {}
